import styled from 'styled-components'

import { theme } from '@provi/provi-components'

export const Span = styled.span`
  color: ${theme.colors.blue600};
`
